<template>
  <div class="page-wrapper">
    <div class="container-fluid p-0">
      <div class="authentication-main">
        <div class="row">
          <div class="col-md-12">
            <div class="auth-innerright">
              <div class="authentication-box">
                <div class="text-center">
                  <img alt="Wakili" src="@/assets/images/endless-logo.png">
                </div>
                <div class="card mt-4">
                  <div class="card-body">
                    <div class="text-center">
                      <h4>LOGIN</h4>
                      <h6>Sign in to your firm account</h6>
                    </div>
                    <form class="theme-form" @submit.prevent="doLogin">
                      <div v-if="error" class="alert alert-danger" role="alert">
                        {{ error }}
                      </div>
                      <div class="form-group form-field">
                        <label class="col-form-label">Company code</label>
                        <input
                          v-model="companyCode"
                          class="form-control"
                          type="text"
                          placeholder="acme-law"
                          required
                          autocomplete="organization"
                        >
                      </div>
                      <div class="form-group form-field">
                        <label class="col-form-label">Email or phone number</label>
                        <input
                          v-model="loginId"
                          class="form-control"
                          type="text"
                          placeholder="john@acmelaw.com or 0700000000"
                          required
                          autocomplete="username"
                        >
                      </div>
                      <div class="form-group form-field">
                        <label class="col-form-label">Password</label>
                        <input
                          v-model="password"
                          :type="type"
                          class="form-control"
                          placeholder="*********"
                          required
                          autocomplete="current-password"
                        >
                        <div class="show-hide">
                          <span class="show" @click="showPassword"></span>
                        </div>
                      </div>
                      <div class="checkbox p-0">
                        <input id="checkbox1" v-model="rememberMe" type="checkbox">
                        <label for="checkbox1">Remember me</label>
                      </div>
                      <div class="form-row mt-3">
                        <button
                          class="btn btn-primary btn-block w-100"
                          type="submit"
                          :disabled="loading"
                        >
                          {{ loading ? 'Signing in...' : 'Sign in' }}
                        </button>
                      </div>
                      <div class="text-center mt-3">
                        <router-link :to="{ name: 'admin-login' }" class="text-muted">
                          Platform admin login
                        </router-link>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

const REMEMBERED_COMPANY_CODE_KEY = 'rememberedCompanyCode'
const REMEMBERED_LOGIN_KEY = 'rememberedLogin'

export default {
  data() {
    return {
      type: 'password',
      companyCode: localStorage.getItem(REMEMBERED_COMPANY_CODE_KEY) || '',
      loginId: localStorage.getItem(REMEMBERED_LOGIN_KEY) || '',
      password: '',
      rememberMe: !!(
        localStorage.getItem(REMEMBERED_COMPANY_CODE_KEY)
        || localStorage.getItem(REMEMBERED_LOGIN_KEY)
      ),
      loading: false,
      error: '',
    }
  },

  methods: {
    ...mapActions('auth', ['login']),

    showPassword() {
      this.type = this.type === 'password' ? 'text' : 'password'
    },

    async doLogin() {
      this.error = ''
      this.loading = true

      try {
        await this.login({
          companyCode: this.companyCode.trim(),
          login: this.loginId.trim(),
          password: this.password,
        })

        if (this.rememberMe) {
          localStorage.setItem(REMEMBERED_COMPANY_CODE_KEY, this.companyCode.trim())
          localStorage.setItem(REMEMBERED_LOGIN_KEY, this.loginId.trim())
        } else {
          localStorage.removeItem(REMEMBERED_COMPANY_CODE_KEY)
          localStorage.removeItem(REMEMBERED_LOGIN_KEY)
        }

        const redirect = this.$route.query.redirect || { name: 'tenant-dashboard' }
        this.$router.replace(redirect)
      } catch (err) {
        this.error = err.message || 'Invalid login or password'
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
